import axios from "axios";
import React, { Component, useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import {
  set_datapage,
  getMapStateDefault,
} from "@ora/recursos/src/redux/actions/DataPageAction";
import { baseUrl, localUrl } from "@ora/recursos/src/helpers/Url";
import qs from "query-string";
import { Chart } from "react-google-charts";
import $ from "jquery";
import dt from "datatables.net";
import "css/reportes/scrollbar.css";
import typeahead from "corejs-typeahead";
import { stubFalse } from "lodash";
import { PageLength } from "helpers/Datatables";
import { Helpers, Templates } from "@ora/recursos";
$.DataTable = dt;
$.typeahead = typeahead;

class ExportacionesCites extends Component {
  filter = {
    buscar: "",
  };
  datatable = null;
  constructor(props) {
    super(props);

    this.state = {
      chart_1: null,
      chart_2: null,
      chart_3: null,
      lista: false,
      cites: false,
      iucn: false,
      paises: false,
      recursos: false,
      tiporecurso: false,
      search: {
        txt_ncc: "",
        sel_year: "",
        sel_iucn: "",
        sel_recurso: "",
        sel_tiporecurso: "",
        sel_pais: "",
      },
      filter: {},
      regpag: process.env.REG_PAG,
      dataLoadingStatus: "loading",
      chartData: [],
      total: 0,
      datosCargados: false,
    };
  }
  setDataPage = () => {
    this.props.set_datapage({
      titulo: this.props.language("expor_citesexportacion"),
      isbackend: false,
      hasHeroBar: true,
      hasBreadcrumb: false,
      be_itemselect: "exportaciones_cites", //clave de item del menu backend que se debe activar
      breadcrumb: [
        { name: "Inicio", url: localUrl("/") },
        { name: "Reportes", url: "#" },
        {
          name: this.props.language("expor_citesexportacion"),
          url: "#",
          active: true,
        },
      ],
    });
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    console.log("ENLACES", prevProps.countDataPage, this.props.countDataPage);
    if (100 === +this.props.countDataPage) {
      this.setDataPage();
    }
  }

  initTypeahead = () => {
    const fnTargetText = (e, data) => {
      this.setState({
        search: {
          ...this.state.search,
          txt_ncc: data.text,
        },
      });
    };
    $("#txt_ncc")
      .typeahead(
        {
          highlight: true,
          hint: false,
          minLength: 1,
        },
        {
          async: true,
          name: "search-exportaciones",
          display: function display(d) {
            return d.text;
          },
          templates: {
            suggestion: (h) => {
              if (h.asPlaceholder !== undefined) {
                return `<div>Buscar <b>"${h.text}"</b></div>`;
              } else return `<div>${h.text}</div>`;
            },
          },
          source: function source(q, cb, asy) {
            // let result = []
            if (q.trim() != "") {
              // var no_buscar = _this.cilindros.map(function (v) {
              //     return v.id;
              // });
              // console.log(no_buscar);
              // axios.get(BASE_URL + '/api/cilindro?m=all&q=' + q, {params: {cilindros: no_buscar}}).then(res => {
              cb([{ count: 0, asPlaceholder: true, text: q.trim() }]);
              axios
                .get(baseUrl("cites/exportaciones/typeahead"), {
                  params: { q: q.trim() },
                })
                .then(function (res) {
                  // console.log(res.data)
                  // return res.data
                  // res.data.unshift({count: 0, text: `Solo buscar "${q.trim()}"` })
                  asy(res.data);
                  // return res.data
                });

              // let regex = new RegExp(q, 'i');
              // cb(_this.listaBancos.filter(v => {
              //   return regex.test(v.banco_name)
              // }))
            }
          },
        }
      )
      .bind("typeahead:select", fnTargetText)
      .bind("typeahead:autocomplete", fnTargetText);
  };

  componentDidMount() {
    var params = qs.parse(this.props.location.search);
    this.setDataPage();
    var url = baseUrl(`cites/reportes/initexportacionescites?`);

    var search = this.state.search;
    if (params["q1"]) {
      search["txt_ncc"] = params["q1"];
      url += "&q1=" + params["q1"];
    }
    if (params["q2"]) {
      search["sel_year"] = params["q2"];
      url += "&q2=" + params["q2"];
    }
    if (params["q3"]) {
      search["sel_iucn"] = params["q3"];
      url += "&q3=" + params["q3"];
    }
    if (params["q4"]) {
      search["sel_tiporecurso"] = params["q4"];
      url += "&q4=" + params["q4"];
    }

    this.setState({
      search: search,
    });

    this.setFilter();

    axios.get(url).then((res) => {
      this.initpage(res.data);
    });
  }

  setFilter() {
    this.setState({
      filter: {
        q1: this.state.search["txt_ncc"],
        q2: this.state.search["sel_year"],
        q3: this.state.search["sel_iucn"],
        q4: this.state.search["sel_tiporecurso"],
      },
    });
  }
  initpage(result) {
    var resultados = result;
    console.info("%c--- get reporte ", "color:yellow;background:green");
    var search = this.state.search;
    const itemYear = resultados.year.map((item, index) => {
      var selected = false;
      if (+this.state.search["sel_year"] === +item.exp_int_year) {
        search["sel_year"] = item.exp_int_year;
        selected = true;
      }
      return (
        <option key={index + '-' + item.exp_int_year} value={item.exp_int_year} selected={ selected }>
          {item.exp_int_year}
        </option>
      );
    });
    const itemPaises = resultados.paises.map((item, index) => {
      var selected = false;
    //   console.log('vvvvvvvtttttttttttttttttttttttttttttt', this.state.search["sel_iucn"], item.code)
      if (this.state.search["sel_iucn"] === item.code) {
        search["sel_iucn"] = item.code;
        selected = true;
      }
      return (
        <option key={index + '-' + item.code} value={item.code} selected={ selected }>
          {item.name}
        </option>
      );
    });

    this.setState({
      year: itemYear,
      paises: itemPaises,
      search: search,
    });
    this.getSearch();
  }
  
  onClick_descargar = (e) => {
    e.preventDefault()
    let tokenDownload = Helpers.ValidationAuth.getPublicAuthorization().replace('Basic', '').replace(' ', '').trim()
    let params = this.datatable.ajax.params()
    window.open(baseUrl("cites/reportes/exportacion_datatable?l=25&o=0&tq=1") + '&' + $.param(params) + '&format=download' + (tokenDownload ? `&token=${tokenDownload}` : ''), '_blank').focus();
  }
  initDatatable = () => {
    const OnClick_acciones = (evt) => {
      let { accion, id } = evt.currentTarget.dataset;
      switch (accion) {
        case "ver":
          this.props.history.push(localUrl("/reportes/comercios/" + id));
          break;
      }
    };
    this.configDT = {
      data: [],
      dom: "<'columns'<'column is-full'<'table-container't>>><'columns p-4'<'column'l><'column'p>>",
      processing: true,
      pageLength: PageLength(),
      ajax: {
        url: baseUrl("cites/reportes/exportacion_datatable?l=25&o=0&tq=1"),
        data: (d) => {
          d.filter = {
            q1: this.state.search["txt_ncc"],
            q2: this.state.search["sel_year"],
            q3: this.state.search["sel_iucn"],
            q4: this.state.search["sel_tiporecurso"],
          };
          return d;
        },
      },
      serverSide: true,
      order: [[0, "asc"]],
      createdRow: (r, d, i) => {},
      columns: [
        {
          data: "exp_int_id",
          render: (d, t, r) => {
            return r.index;
          },
        },
        { data: "exp_int_year" },
        { data: "exp_txt_taxon" },
        { data: "exp_txt_term" },
        { data: "exp_int_quantity" },
        { data: "exp_txt_unit" },
        { data: "pais_exporter" },
        { data: "pais_importer" },
        { data: "exp_txt_appendix" },
        {
          data: "exp_int_id",
          render: (d, t, r) => {
            return `
                  <div class="buttons is-centered">
                  <button data-id="${d}" data-accion="ver" class="button is-small is-primary btn-acciones buttonb" title="Ver">
                      <span class="icon is-small"><i class="fas fa-eye"></i></span>
                  </button>
              </div>
                    `;
          },
        },
      ],
      drawCallback: () => {
        $("#tblExportacion_paginate a.previous").addClass(
          "pagination-link pagination-previous"
        );
        $("#tblExportacion_paginate a.next").addClass(
          "pagination-link pagination-next"
        );
        $("#tblExportacion_paginate a.next").addClass(
          "pagination-link pagination-next"
        );
        $("#tblExportacion_paginate span a.paginate_button.current").addClass(
          "pagination-link is-current"
        );
        $("#tblExportacion_paginate span a.paginate_button").addClass(
          "pagination-link"
        );
      },
    };
    this.table = $("#tblExportacion");

    // setTimeout(() => {

    this.datatable = this.table
      .DataTable(this.configDT)
      .on("click", ".btn-acciones", OnClick_acciones);

    // }, 20000)
  };

  cargarchartyear(datos) {
    // let year = [
    //     ['Años', 'Cantidad']
    // ]
    let DataChart = [];
    let filaDatachart = [];
    let row;
    let isFirstRow = true;

    let arrayData = Object.entries(datos.yearchart);

    datos.yearimp.map((year) => {
      //CABECERA
      if (isFirstRow) {
        filaDatachart.push("Año");
        datos.paisimp.forEach((pais) => {
          filaDatachart.push(pais.pais);
        });
        DataChart.push(filaDatachart);
        filaDatachart = [];
      }

      //CONTENIDO
      filaDatachart.push(year.exp_int_year); //PRIMER ELEMENTO DEL ROW
      //console.log(data[1].pais)
      datos.paisimp.forEach((pais) => {
        row = arrayData.find(
          (data) =>
            data[1].pais == pais.pais &&
            data[1].exp_int_year == year.exp_int_year
        ); //CONDICION

        if (row)
          //SI EXISTE EL ELEMENTO CON ESA CONDICION
          filaDatachart.push(
            parseInt(row[1].cantidad)
          ); //AGREGA EL ATRIBUTO SOLICITADO
        else filaDatachart.push(0);
      });

      DataChart.push(filaDatachart);
      filaDatachart = [];
      isFirstRow = false;
    });

    this.setState({
      yearChart: DataChart,
      dataLoadingStatus: "ready",
    });

    this.initTypeahead();
    this.initDatatable();
  }
  cargarchartpresentacionyear(datos) {
    let DataChart = [];
    let filaDatachart = [];
    let row;
    let isFirstRow = true;

    let arrayData = Object.entries(datos.termimp);

    datos.yearimp.forEach((year) => {
      //CABECERA
      if (isFirstRow) {
        filaDatachart.push("Año");
        datos.allterm.map((term) => {
          filaDatachart.push(term.termino);
        });
        DataChart.push(filaDatachart);
        filaDatachart = [];
      }

      //CONTENIDO
      filaDatachart.push(year.exp_int_year); //PRIMER ELEMENTO DEL ROW
      //console.log(datos.allterm)
      datos.allterm.forEach((term) => {
        row = arrayData.find(
          (data) =>
            data[1].termino === term.termino &&
            +data[1].exp_int_year === +year.exp_int_year
        ); //CONDICION
        //console.log(data)
        if (row)
          //SI EXISTE EL ELEMENTO CON ESA CONDICION
          filaDatachart.push(
            parseInt(row[1].cantidad)
          ); //AGREGA EL ATRIBUTO SOLICITADO
        else filaDatachart.push(0);
      });
      //console.log(DataChart)
      DataChart.push(filaDatachart);
      filaDatachart = [];
      isFirstRow = false;
    });

    //console.log(DataChart)
    this.setState({
      termChart: DataChart,
    });
  }
  cargarchartespeciepais(datos) {
    let DataChart = [];
    let filaDatachart = [];
    let row;
    let isFirstRow = true;

    let arrayData = Object.entries(datos.espepais);

    datos.alltaxon.forEach((taxon) => {
      //CABECERA
      if (isFirstRow) {
        filaDatachart.push("Especie");
        datos.paisimp.forEach((pais) => {
          filaDatachart.push(pais.pais);
        });
        DataChart.push(filaDatachart);
        filaDatachart = [];
      }

      //CONTENIDO
      filaDatachart.push(taxon.exp_txt_taxon); //PRIMER ELEMENTO DEL ROW
      //console.log(data[1].pais)
      datos.paisimp.forEach((pais) => {
        row = arrayData.find(
          (data) =>
            data[1].pais == pais.pais && data[1].especie === taxon.exp_txt_taxon
        ); //CONDICION
        //console.log(arrayData)
        if (row)
          //SI EXISTE EL ELEMENTO CON ESA CONDICION
          filaDatachart.push(
            parseInt(row[1].cantidad)
          ); //AGREGA EL ATRIBUTO SOLICITADO
        else filaDatachart.push(0);
      });
      //console.log(DataChart)
      DataChart.push(filaDatachart);
      filaDatachart = [];
      isFirstRow = false;
    });

    //console.log(DataChart)
    this.setState({
      taxonChart: DataChart,
    });
  }
  cargarchartimporter(datos) {
    let DataChart = [];
    let filaDatachart = [];
    let row;
    let isFirstRow = true;

    let arrayData = Object.entries(datos.presenpais);

    datos.allpresen.forEach((term) => {
      //CABECERA
      if (isFirstRow) {
        filaDatachart.push("Presentacion");
        datos.paisimp.forEach((pais) => {
          filaDatachart.push(pais.pais);
        });
        DataChart.push(filaDatachart);
        filaDatachart = [];
      }

      //CONTENIDO
      filaDatachart.push(term.exp_txt_term); //PRIMER ELEMENTO DEL ROW
      //console.log(data[1].pais)
      datos.paisimp.forEach((pais) => {
        row = arrayData.find(
          (data) =>
            data[1].pais == pais.pais && data[1].termino == term.exp_txt_term
        ); //CONDICION
        //console.log(arrayData)
        if (row)
          //SI EXISTE EL ELEMENTO CON ESA CONDICION
          filaDatachart.push(
            parseInt(row[1].cantidad)
          ); //AGREGA EL ATRIBUTO SOLICITADO
        else filaDatachart.push(0);
      });
      //console.log(DataChart)
      DataChart.push(filaDatachart);
      filaDatachart = [];
      isFirstRow = false;
    });

    //console.log(DataChart)
    this.setState({
      presenChart: DataChart,
    });
  }
  cargarchartespecieyear(datos) {
    let DataChart = [];
    let filaDatachart = [];
    let row;
    let isFirstRow = true;

    let arrayData = Object.entries(datos.taxonyear);
    let nombrepais = datos.isocodepais[0].pais;
    //console.log(nombrepais)

    datos.alltaxon.forEach((taxon) => {
      //CABECERA
      if (isFirstRow) {
        filaDatachart.push("Especie");
        datos.yearimp.forEach((year) => {
          filaDatachart.push(year.exp_int_year);
        });
        DataChart.push(filaDatachart);
        filaDatachart = [];
      }

      //CONTENIDO
      filaDatachart.push(taxon.exp_txt_taxon); //PRIMER ELEMENTO DEL ROW
      //console.log(data[1].pais)
      datos.yearimp.forEach((year) => {
        row = arrayData.find(
          (data) =>
            data[1].exp_int_year == year.exp_int_year &&
            data[1].especie == taxon.exp_txt_taxon
        ); //CONDICION
        //console.log(arrayData)
        if (row)
          //SI EXISTE EL ELEMENTO CON ESA CONDICION
          filaDatachart.push(
            parseInt(row[1].cantidad)
          ); //AGREGA EL ATRIBUTO SOLICITADO
        else filaDatachart.push(0);
      });
      //console.log(DataChart)
      DataChart.push(filaDatachart);
      filaDatachart = [];
      isFirstRow = false;
    });

    //console.log(DataChart)
    this.setState({
      taxonyearChart: DataChart,
      nombrepais: nombrepais,
    });
  }
//   cargarcharttermyear(datos) {
//     let DataChart = [];
//     let filaDatachart = [];
//     let row;
//     let isFirstRow = true;

//     let arrayData = Object.entries(datos.termyear);

//     datos.allpresen.forEach((term) => {
//       //CABECERA
//       if (isFirstRow) {
//         filaDatachart.push("Especie");
//         datos.yearimp.forEach((year) => {
//           filaDatachart.push(year.exp_int_year);
//         });
//         DataChart.push(filaDatachart);
//         filaDatachart = [];
//       }

//       //CONTENIDO
//       filaDatachart.push(term.exp_txt_term); //PRIMER ELEMENTO DEL ROW
//       //console.log(data[1].pais)
//       datos.yearimp.forEach((year) => {
//         row = arrayData.find(
//           (data) =>
//             data[1].exp_int_year == year.exp_int_year &&
//             data[1].exp_txt_term == term.exp_txt_term
//         ); //CONDICION
//         //console.log(arrayData)
//         if (row)
//           //SI EXISTE EL ELEMENTO CON ESA CONDICION
//           filaDatachart.push(
//             parseInt(row[1].cantidad)
//           ); //AGREGA EL ATRIBUTO SOLICITADO
//         else filaDatachart.push(0);
//       });
//       //console.log(DataChart)
//       DataChart.push(filaDatachart);
//       filaDatachart = [];
//       isFirstRow = false;
//     });

//     //console.log(DataChart)
//     this.setState({
//       termyearChart: DataChart,
//     });
//   }
  cargarchartpaiscantidad(datos) {
    let paiscant = [["Pais", "Cantidad"]];
    datos.paiscantidadchart.forEach((item, index) => {
      //console.log(datos.yearchart)
      paiscant.push([item.pais, parseInt(item.cantidad)]);
    });
    this.setState({
      paiscantidadchart: paiscant,
    });
  }
  cargarcharttermpais(datos) {
    let DataChart = [];
    let filaDatachart = [];
    let row;
    let isFirstRow = true;

    let arrayData = Object.entries(datos.presenpais);

    datos.allpresen.forEach((term) => {
      //CABECERA
      if (isFirstRow) {
        filaDatachart.push("Presentacion");
        datos.paisimp.forEach((pais) => {
          filaDatachart.push(pais.pais);
        });
        DataChart.push(filaDatachart);
        filaDatachart = [];
      }

      //CONTENIDO
      filaDatachart.push(term.exp_txt_term); //PRIMER ELEMENTO DEL ROW
      //console.log(data[1].pais)
      datos.paisimp.forEach((pais) => {
        row = arrayData.find(
          (data) =>
            data[1].pais == pais.pais && data[1].termino == term.exp_txt_term
        ); //CONDICION
        //console.log(arrayData)
        if (row)
          //SI EXISTE EL ELEMENTO CON ESA CONDICION
          filaDatachart.push(
            parseInt(row[1].cantidad)
          ); //AGREGA EL ATRIBUTO SOLICITADO
        else filaDatachart.push(0);
      });
      //console.log(DataChart)
      DataChart.push(filaDatachart);
      filaDatachart = [];
      isFirstRow = false;
    });

    //console.log(DataChart)
    this.setState({
      presenChart: DataChart,
    });
  }
  cargarchartyearcantidad(datos) {
    let yearcant = [["Año", "Cantidad"]];
    datos.yearcantidadchart.forEach((item, index) => {
      //console.log(datos.yearchart)
      yearcant.push([item.pais, parseInt(item.cantidad)]);
    });
    this.setState({
      yearcantidadchart: yearcant,
    });
  }
//   cargarcharttermyear(datos) {
//     let DataChart = [];
//     let filaDatachart = [];
//     let row;
//     let isFirstRow = true;

//     let arrayData = Object.entries(datos.termimp);

//     datos.yearimp.forEach((year) => {
//       //CABECERA
//       if (isFirstRow) {
//         filaDatachart.push("Año");
//         datos.allterm.forEach((term) => {
//           filaDatachart.push(term.termino);
//         });
//         DataChart.push(filaDatachart);
//         filaDatachart = [];
//       }

//       //CONTENIDO
//       filaDatachart.push(year.exp_int_year); //PRIMER ELEMENTO DEL ROW
//       //console.log(datos.allterm)
//       datos.allterm.forEach((term) => {
//         row = arrayData.find(
//           (data) =>
//             data[1].termino == term.termino &&
//             data[1].exp_int_year == year.exp_int_year
//         ); //CONDICION
//         //console.log(data)
//         if (row)
//           //SI EXISTE EL ELEMENTO CON ESA CONDICION
//           filaDatachart.push(
//             parseInt(row[1].cantidad)
//           ); //AGREGA EL ATRIBUTO SOLICITADO
//         else filaDatachart.push(0);
//       });
//       //console.log(DataChart)
//       DataChart.push(filaDatachart);
//       filaDatachart = [];
//       isFirstRow = false;
//     });

//     //console.log(DataChart)
//     this.setState({
//       termyearChart: DataChart,
//     });
//   }
  cargarcharttaxoncantidad(datos) {
    let yearcant = [["Especie", "Cantidad"]];
    datos.especiecantidadchart.forEach((item, index) => {
      //console.log(datos.yearchart)
      yearcant.push([item.pais, parseInt(item.cantidad)]);
    });
    this.setState({
      yearcantidadchart: yearcant,
    });
  }
  cargarchartespecantidad(datos) {
    let especant = [["Especie", "Cantidad"]];
    datos.especantidadchart.forEach((item, index) => {
      //console.log(datos.yearchart)
      especant.push([item.exp_txt_taxon, parseInt(item.cantidad)]);
    });
    this.setState({
      especantidadchart: especant,
    });
  }
  cargarcharttermcantidad(datos) {
    let tecant = [["Presentacion", "Cantidad"]];
    datos.termcantidadchart.forEach((item, index) => {
      //console.log(datos.yearchart)
      tecant.push([item.exp_txt_term, parseInt(item.cantidad)]);
    });
    this.setState({
      tecantidadchart: tecant,
    });
  }

  buscar_simple = () => {
    $("#btnBuscar").addClass("is-loading");
    this.datatable.destroy();
    this.getSearch();
    var url = this.getParamsUrl("/reportes/exportaciones?");
    this.props.history.push(localUrl(url));
    this.setFilter();
  };
  getSearch() {
    let url = this.getParamsUrl("cites/reportes/exportacionescites");
    url = baseUrl(url);

    this.setState({ datosCargados: true });

    let url_reportes;
    let func;
    let loading = (
      <div className="field">
        <h2 className="tamano is-2"> { this.props.language('cargando', 'Cargando') }... </h2>
      </div>
    );
    let is_one_chart = false;
    let chart_1_loading = "";
    let chart_2_loading = "";

    if (
      this.state.search.txt_ncc &&
      this.state.search.sel_year &&
      this.state.search.sel_iucn
    ) {
      url_reportes = this.getParamsUrl(
        "cites/reportes/exportacionescites?f=q1q2q3&"
      );
      url_reportes = baseUrl(url_reportes);
      func = "func_q1q2q3";

      is_one_chart = true;
    } else if (this.state.search.txt_ncc && this.state.search.sel_year) {
      url_reportes = this.getParamsUrl(
        "cites/reportes/exportacionescites?f=q1q2&"
      );
      url_reportes = baseUrl(url_reportes);
      func = "func_q1q2";

      is_one_chart = false;
    } else if (this.state.search.txt_ncc && this.state.search.sel_iucn) {
      url_reportes = this.getParamsUrl(
        "cites/reportes/exportacionescites?f=q1q3&"
      );
      url_reportes = baseUrl(url_reportes);
      func = "func_q1q3";

      is_one_chart = false;
    } else if (this.state.search.sel_year && this.state.search.sel_iucn) {
      url_reportes = this.getParamsUrl(
        "cites/reportes/exportacionescites?f=q2q3&"
      );
      url_reportes = baseUrl(url_reportes);
      func = "func_q2q3";

      is_one_chart = false;
    } else if (this.state.search.txt_ncc) {
      url_reportes = this.getParamsUrl(
        "cites/reportes/exportacionescites?f=q1&"
      );
      url_reportes = baseUrl(url_reportes);
      func = "func_q1";

      is_one_chart = false;
    } else if (this.state.search.sel_year) {
      url_reportes = this.getParamsUrl(
        "cites/reportes/exportacionescites?f=q2&"
      );
      url_reportes = baseUrl(url_reportes);
      func = "func_q2";

      is_one_chart = false;
    } else if (this.state.search.sel_iucn) {
      url_reportes = this.getParamsUrl(
        "cites/reportes/exportacionescites?f=q3&"
      );
      url_reportes = baseUrl(url_reportes);
      func = "func_q3";

      is_one_chart = false;
    } else {
      url_reportes = this.getParamsUrl(
        "cites/reportes/exportacionescites?f=no_q"
      );
      url_reportes = baseUrl(url_reportes);
      func = "func_no_q";

      is_one_chart = false;
    }

    if (is_one_chart) {
      chart_1_loading = loading;
      chart_2_loading = "";
    } else {
      chart_1_loading = loading;
      chart_2_loading = loading;
    }

    //alert(url_reportes)

    this.setState({
      chart_1: chart_1_loading,
      chart_3: "",
      chart_2: chart_2_loading,
    });

    axios.get(url_reportes).then((res) => {
      //alert(func)

      this[func](res.data.datos);

      this.initTypeahead();
      this.initDatatable();
      $("#btnBuscar").removeClass("is-loading");

      this.setState({
        dataLoadingStatus: "ready",
        total: res.data.datos.total,
      });
    });
  }

  //Cargar chart barras multiples
  cargarchartbarrasmultiples(
    datos,
    data_x_column,
    axis_y_column,
    x,
    name_x,
    y,
    y_first_name,
    name_y,
    charName,
    confObjChar,
    label_x = false
  ) {
    console.log("vvvvvvvvvvvvvv", datos);
    console.log("charName", charName);
    // let year = [
    //     ['Años', 'Cantidad']
    // ]
    if (datos === undefined) return false;

    let DataChart = [];
    let filaDatachart = [];
    let row;
    let isFirstRow = true;
    let total_data = 0;

    let arrayData = Object.entries(datos);

    y.forEach((y_el) => {
      //CABECERA
      if (isFirstRow) {
        filaDatachart.push(y_first_name);
        x.forEach((x_el) => {
          filaDatachart.push(x_el[label_x || name_x]);
        });
        DataChart.push(filaDatachart);
        filaDatachart = [];
      }

      //CONTENIDO
      filaDatachart.push(y_el[name_y]); //PRIMER ELEMENTO DEL ROW
      //console.log(data[1].pais)
      x.forEach((x_el) => {
        let i = x_el[name_x];
        let j = y_el[name_y];
        // console.log('qqqqqqqqqqqqqqqqqqqq', i, j, name_x, name_y)
        //console.log(j)
        //console.log(i)

        row = arrayData.find(
          (data) => data[1][data_x_column] == i && data[1][axis_y_column] == j
        ); //CONDICION

        if (row) {
          //SI EXISTE EL ELEMENTO CON ESA CONDICION´
          total_data = total_data + 1;
          filaDatachart.push(parseInt(row[1].cantidad)); //AGREGA EL ATRIBUTO SOLICITADO
        } else filaDatachart.push(0);
      });

      DataChart.push(filaDatachart);
      filaDatachart = [];
      isFirstRow = false;
    });

    let render = this.renderChart(DataChart, total_data, confObjChar);
    console.log("aaaaaaaaaaaa render", render);
    // if (charName !== 'chart_1') {

    this.setState({
      [charName]: render,
      dataLoadingStatus: "ready",
    });
    // }
  }
  //Chart barras simple
  cargarChartBarrasSimple(
    datos,
    x_first,
    x_col,
    y_first,
    y_col,
    chartName,
    confObjChar
  ) {
    console.log("vvvvvvvvvvvvvvvvvv cargarChartBarrasSimple", datos);
    let totalData = 0;
    let dataChart = [[x_first, y_first]];

    datos.map((item, index) => {
      //console.log(datos.yearchart)
      totalData = totalData + 1;
      dataChart.push([item[x_col], parseInt(item[y_col])]);
    });
    this.setState({
      [chartName]: this.renderChart(dataChart, totalData, confObjChar),
    });
  }

  //Fin chart barras simple

  //RenderizarChart
  renderChart(data, total_data, objConf) {
    console.log("AAAAAAAAAAAA", data, total_data, objConf);

    if (total_data > 0) {
      let CharTitle = objConf.CharTitle;
      let hAxisTitle = objConf.hAxisTitle;
      let vAxisTitle = objConf.vAxisTitle;
      let id = objConf.id;

      return (
        <Chart
          width={"100%"}
          height={"400px"}
          chartType="BarChart"
          loader={<div>Loading Chart</div>}
          data={data}
          options={{
            fontSize: 11,
            legend: {
              position: "bottom",
              textStyle: { fontSize: 12 },
              maxLines: 3,
            },
            title: CharTitle,
            chartArea: { width: "65%" },
            isStacked: true,
            hAxis: {
              title: hAxisTitle,
              minValue: 0,
              titleTextStyle: {
                fontSize: 14,
                // color: '#FF0000'
              }
            },
            // axes: {
            //   y: {
            //     distance: {label: 'parsecs'}, // Bottom x-axis.
            //     brightness: {side: 'top', label: 'apparent magnitude'} // Top x-axis.
            //   }
            // },
            vAxis: {
              title: vAxisTitle,
              titleTextStyle: {
                fontSize: 14,
                // color: '#FF0000'
              }
            },
          }}
          // For tests
          rootProps={{ "data-testid": id }}
        />
      );
    } else {
      return (
        <h4>
          {this.props.language("nse_registros", "No se encontraron registros")}
        </h4>
      );
    }
  }

  //traer reportes

  //sin parámetros
  func_no_q(data) {
    let objConf1 = {
      CharTitle: this.props.language("expor_graficonoq1"),
      hAxisTitle: "Cantidad",
      vAxisTitle: "Año",
      id: "1",
    };
    this.cargarchartbarrasmultiples(
      data.chart_1,
      "pais",
      "exp_int_year",
      data.x_1,
      "pais",
      data.y,
      "Año",
      "exp_int_year",
      "chart_1",
      objConf1
    );

    let objConf2 = {
      CharTitle: this.props.language("expor_graficonoq2"),
      hAxisTitle: "Cantidad",
      vAxisTitle: "Año",
      id: "2",
    };
    this.cargarchartbarrasmultiples(
      data.chart_2,
      "termino",
      "exp_int_year",
      data.x_2,
      "termino",
      data.y,
      "Especie",
      "exp_int_year",
      "chart_2",
      objConf2
    );

    let objConf3 = {
      CharTitle: this.props.language("expor_graficono_destinoq1"),
      hAxisTitle: "Cantidad",
      vAxisTitle: "Año",
      id: "3",
    };

    this.cargarchartbarrasmultiples(
      data.chart_3,
      "pais",
      "exp_int_year",
      data.x_3,
      "pais",
      data.y,
      "Año",
      "exp_int_year",
      "chart_3",
      objConf3
    );
  }

  func_q1(data) {
    let objConf1 = {
      CharTitle:
        this.props.language("expor_graficoq11") +
        " " +
        this.state.search["txt_ncc"],
      hAxisTitle: "Cantidad",
      vAxisTitle: "Año",
      id: "1",
    };
    this.cargarchartbarrasmultiples(
      data.chart_1,
      "pais",
      "exp_int_year",
      data.x_1,
      "pais",
      data.y,
      "Año",
      "exp_int_year",
      "chart_1",
      objConf1
    );

    let objConf2 = {
      CharTitle:
        this.props.language("expor_graficoq12") +
        " " +
        this.state.search["txt_ncc"],
      hAxisTitle: "Cantidad",
      vAxisTitle: "Año",
      id: "2",
    };
    this.cargarchartbarrasmultiples(
      data.chart_2,
      "termino",
      "exp_int_year",
      data.x_2,
      "termino",
      data.y,
      "Especie",
      "exp_int_year",
      "chart_2",
      objConf2,
      'var_txt_name'
    );

    let objConf3 = {
      CharTitle:
        this.props.language("expor_grafico_destinoq11") +
        " " +
        this.state.search["txt_ncc"],
      hAxisTitle: "Cantidad",
      vAxisTitle: "Año",
      id: "3",
    };

    this.cargarchartbarrasmultiples(
      data.chart_3,
      "pais",
      "exp_int_year",
      data.x_3,
      "pais",
      data.y,
      "Año",
      "exp_int_year",
      "chart_3",
      objConf3
    );
  }

  func_q2(data) {
    let objConf1 = {
      CharTitle:
        this.props.language("expor_graficoq21") +
        " " +
        this.state.search.sel_year,
      hAxisTitle: "Cantidad",
      vAxisTitle: "Especie",
      id: "1",
    };
    this.cargarchartbarrasmultiples(
      data.chart_1,
      "pais",
      "especie",
      data.x,
      "pais",
      data.y_1,
      "Año",
      "exp_txt_taxon",
      "chart_1",
      objConf1
    );

    let objConf2 = {
      CharTitle:
        this.props.language("expor_graficoq22") +
        " " +
        this.state.search.sel_year,
      hAxisTitle: "Cantidad",
      vAxisTitle: "Presentación",
      id: "2",
    };
    this.cargarchartbarrasmultiples(
      data.chart_2,
      "pais",
      "termino",
      data.x,
      "pais",
      data.y_2,
      "Especie",
      "exp_txt_term",
      "chart_2",
      objConf2
    );

    let objConf3 = {
      CharTitle:
        this.props.language("expor_grafico_destinoq21") +
        " " +
        this.state.search.sel_year,
      hAxisTitle: "Cantidad",
      vAxisTitle: "Año",
      id: "3",
    };

    this.cargarchartbarrasmultiples(
      data.chart_3,
      "pais",
      "exp_int_year",
      data.x_3,
      "pais",
      data.y,
      "Año",
      "exp_int_year",
      "chart_3",
      objConf3
    );
  }

  func_q3(data) {
    let objConf1 = {
      CharTitle:
        this.props.language("expor_graficoq31") + " " + data.isocode_pais,
      hAxisTitle: "Cantidad",
      vAxisTitle: "Especie",
      id: "1",
    };
    this.cargarchartbarrasmultiples(
      data.chart_1,
      "exp_int_year",
      "especie",
      data.x_1,
      "exp_int_year",
      data.y_1,
      "Especie",
      "exp_txt_taxon",
      "chart_1",
      objConf1
    );

    let objConf2 = {
      CharTitle:
        this.props.language("expor_graficoq32") + " " + data.isocode_pais,
      hAxisTitle: "Cantidad",
      vAxisTitle: "Presentación",
      id: "2",
    };
    this.cargarchartbarrasmultiples(
      data.chart_2,
      "termino",
      "exp_int_year",
      data.x_2,
      "termino",
      data.y_2,
      "Año",
      "exp_int_year",
      "chart_2",
      objConf2,
      'var_txt_name'
    );
  }

  func_q1q2(data) {
    let objConf1 = {
      CharTitle:
        this.props.language("expor_graficoq1q21") +
        " " +
        this.state.search["txt_ncc"] +
        " " +
        this.props.language("expor_graficoq1q21year") +
        " " +
        this.state.search.sel_year,
      hAxisTitle: "Cantidad",
      vAxisTitle: "País",
      id: "1",
    };
    this.cargarChartBarrasSimple(
      data.chart_1,
      "Pais",
      "pais",
      "Cantidad",
      "cantidad",
      "chart_1",
      objConf1
    );

    let objConf2 = {
      CharTitle:
        this.props.language("expor_graficoq1q22") +
        " " +
        this.state.search["txt_ncc"] +
        " " +
        this.props.language("expor_graficoq1q22porlospaisesmiembros") +
        " " +
        this.state.search.sel_year,
      hAxisTitle: "Cantidad",
      vAxisTitle: "Presentación",
      id: "2",
    };
    this.cargarchartbarrasmultiples(
      data.chart_2,
      "pais",
      "termino",
      data.x_2,
      "pais",
      data.y_2,
      "Año",
      "exp_txt_term",
      "chart_2",
      objConf2
    );
  }
  func_q1q3(data) {
    let objConf1 = {
      CharTitle:
        this.props.language("expor_graficoq1q31") +
        " " +
        data.isocode_pais +
        " " +
        this.props.language("expor_graficoq1q31especie") +
        " " +
        this.state.search.txt_ncc,
      hAxisTitle: "Cantidad",
      vAxisTitle: "Año",
      id: "1",
    };
    this.cargarChartBarrasSimple(
      data.chart_1,
      "Año",
      "exp_int_year",
      "Cantidad",
      "cantidad",
      "chart_1",
      objConf1
    );

    let objConf2 = {
      CharTitle:
        this.props.language("expor_graficoq1q32") +
        " " +
        this.state.search.txt_ncc +
        " en " +
        data.isocode_pais +
        " " +
        this.props.language("expor_graficoq1q32año"),
      hAxisTitle: "Cantidad",
      vAxisTitle: "Año",
      id: "2",
    };
    this.cargarchartbarrasmultiples(
      data.chart_2,
      "exp_txt_term",
      "exp_int_year",
      data.x_2,
      "termino",
      data.y_2,
      "Año",
      "exp_int_year",
      "chart_2",
      objConf2
    );
  }

  func_q2q3(data) {
    let objConf1 = {
      CharTitle:
        this.props.language("expor_graficoq2q31") +
        " " +
        data.isocode_pais +
        " " +
        this.props.language("expor_graficoq1q21year") +
        " " +
        this.state.search.sel_year,
      hAxisTitle: "Cantidad",
      vAxisTitle: "Especie",
      id: "1",
    };
    this.cargarChartBarrasSimple(
      data.chart_1,
      "Taxon",
      "exp_txt_taxon",
      "Cantidad",
      "cantidad",
      "chart_1",
      objConf1
    );

    let objConf2 = {
      CharTitle:
        this.props.language("expor_graficoq2q32") +
        " " +
        data.isocode_pais +
        " " +
        this.props.language("expor_graficoq1q21year") +
        " " +
        this.state.search.sel_year,
      hAxisTitle: "Cantidad",
      vAxisTitle: "Presentación",
      id: "2",
    };
    this.cargarChartBarrasSimple(
      data.chart_2,
      "Término",
      "exp_txt_term",
      "Cantidad",
      "cantidad",
      "chart_2",
      objConf2
    );
  }

  func_q1q2q3(data) {
    let objConf = {
      CharTitle:
        this.props.language("expor_graficoq1q2q3") +
        " " +
        data.isocode_pais +
        " " +
        this.props.language("expor_graficoq1q21year") +
        " " +
        this.state.search.sel_year +
        " " +
        this.props.language("expor_graficoq1q31especie") +
        " " +
        this.state.search["txt_ncc"],
      hAxisTitle: "Cantidad",
      vAxisTitle: "Presentación",
      id: "1",
    };
    this.cargarChartBarrasSimple(
      data.chart_1,
      "Presentación",
      "exp_txt_term",
      "Cantidad",
      "cantidad",
      "chart_1",
      objConf
    );
  }

  getParamsUrl(url) {
    let isFirst = false;
    if (this.state.search["txt_ncc"] != "") {
      if (!isFirst) url += "q1=" + this.state.search["txt_ncc"];
      else url += "&q1=" + this.state.search["txt_ncc"];
      isFirst = true;
    }
    if (this.state.search["sel_year"] != "") {
      if (!isFirst) url += "q2=" + this.state.search["sel_year"];
      else url += "&q2=" + this.state.search["sel_year"];
      isFirst = true;
    }
    if (this.state.search["sel_iucn"] != "") {
      if (!isFirst) url += "q3=" + this.state.search["sel_iucn"];
      else url += "&q3=" + this.state.search["sel_iucn"];
      isFirst = true;
    }
    if (this.state.search["sel_tiporecurso"] != "") {
      if (!isFirst) url += "q4=" + this.state.search["sel_tiporecurso"];
      else url += "&q4=" + this.state.search["sel_tiporecurso"];
      isFirst = true;
    }
    return url;
  }

  ir_detalle = (e) => {
    const { especie } = e.target.dataset;
    var url = "/reportes/fichaespecie/" + especie;
    this.props.history.push(localUrl(url));
  };

  gestionarCambio = (event) => {
    var search = this.state.search;
    if (event.target.type === "radio") {
      search[event.target.name] = event.target.value;
    } else {
      search[event.target.id] = event.target.value;
    }
    this.setState({
      search: search,
    });
  };

  render() {
    return this.state.dataLoadingStatus === "ready" ? (
      <Templates.Default.BasePageRoute2
        localUrl={localUrl}
        dataPage={this.props.DataPage}
      >
        <div>
          <section className="sectionx is-main-section">
            <div className="card">
              <header className="card-header">
                <div className="card-header-title">{ this.props.language('filtro', 'Filtro') }</div>
              </header>
              <div className="card-content">
                <div className="field is-horizontal">
                  <div className="field-body">
                    <div className="field">
                      <label className="label">
                        {this.props.language("expor_nombrecientifico")}
                      </label>
                      <div className="control">
                        <input
                          className="input is-expanded"
                          id="txt_ncc"
                          size="50"
                          type="text"
                          autoComplete="off"
                          placeholder={ this.props.language('gen_ingre_nom_cie_o_com', 'Ingresar nombre de especie') } 
                          onChange={this.gestionarCambio}
                          value={this.state.search.txt_ncc}
                        ></input>
                      </div>
                    </div>
                    <div className="field">
                      <label className="label">
                        {this.props.language("expor_year")}
                      </label>
                      <div className="control">
                        <div className="select">
                          <select id="sel_year" onChange={this.gestionarCambio}>
                            <option value="">-- { this.props.language('seleccionar', 'Seleccionar') } --</option>
                            {this.state.year}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="field ">
                      <label className="label">
                        {this.props.language("expor_pais")}
                      </label>
                      <div className="field is-grouped">
                        <div className="select mr-4">
                          <select id="sel_iucn" onChange={this.gestionarCambio}>
                            <option value="">-- { this.props.language('seleccionar', 'Seleccionar') } --</option>
                            {this.state.paises}
                          </select>
                        </div>
                        <p className="control">
                          <button
                            className="button is-link"
                            id="btnBuscar"
                            onClick={this.buscar_simple}
                          >
                            {this.props.language("expor_buscar")}
                          </button>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card">
              <header className="card-header">
                <div className="card-header-title">
                  {this.props.language("expor_resumen")}
                </div>
              </header>
              <div className="card-content">
                <div className="columns" id="especie1">
                  <div className="column is-12">{this.state.chart_1}</div>
                </div>
                <div className="columns" id="county_destino">
                  <div className="column is-12">{this.state.chart_3}</div>
                </div>
                <div className="columns" id="especie2">
                  <div className="column is-12">{this.state.chart_2}</div>
                </div>
              </div>
            </div>
            <div className="card has-table">
            <div className="notification is-card-toolbar mb-2">
              <div className="level">
                <div className="level-left">
                  <div className="level-item"><strong>{ this.props.language("expor_listresultados") }</strong></div>
                </div>
                <div className="level-right">
                  <div className="level-item">
                    {this.props.language("encontrar", "Se encontraron")}{" "}
                    <strong className="mx-1">{this.state.total}</strong>
                    {this.props.language("registros", "registros")}
                    </div>
                </div>
              </div>
            </div>
              
              <div className="card-content">

                <div className="column">
                <div className="control"><div className="buttons is-justify-content-right"><button onClick={ this.onClick_descargar } id="btnGenerar" className="button is-primary"><i className="fas fa-download"></i>&nbsp;{ this.props.language('descargar', 'Descargar') }</button></div></div>
                </div>
                <div className="xb-table has-pagination">
                  <div className="table-wrapper has-mobile-cards">
                    <table
                      id="tblExportacion"
                      className="table is-fullwidth is-striped is-hoverable is-fullwidth"
                    >
                      <thead>
                        <tr>
                          <th> # </th>
                          <th>Año</th>
                          <th>Taxon</th>
                          <th>Term</th>
                          <th>Volumen</th>
                          <th>Unidad</th>
                          <th>Exportador</th>
                          <th>Importador</th>
                          <th>Apéndice</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody></tbody>
                    </table>
                  </div>
                  {/* <div className="notification">
                                    <div className="level">
                                    <div className="level-left">
                                        <div className="level-item">
                                        <div className="buttons has-addons">
                                            <button type="button" className="button is-active">1</button>
                                            <button type="button" className="button">2</button>
                                            <button type="button" className="button">3</button>
                                        </div>
                                        </div>
                                    </div>
                                    <div className="level-right">
                                        <div className="level-item">
                                        <small>Page 1 of 3</small>
                                        </div>
                                    </div>
                                    </div>
                                </div>  */}
                </div>
              </div>
            </div>
          </section>
        </div>
      </Templates.Default.BasePageRoute2>
    ) : (
      <div className="columns is-justify-content-center mb-6">
        <div className="column is-12">
          <div className="field is-horizontal">
            <div className="field-body">
              <div className="field pt-2">
                <div
                  ref={this.spinnerLoad}
                  className="ld ld-spinner  ld-spin"
                ></div>
              </div>
              <div className="field">
                <h2 className="tamano is-2"> Cargando... </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// export default connect(getLanguage, {set_datapage, SetLanguage})(ExportacionesCites)
export default connect(getMapStateDefault(), {
  set_datapage,
  // seDatatDocumentos,
  // setEstandarData,
  // checkEstandarData,
  // checkDataDirectorio,
})(ExportacionesCites);
